(function () {
  var VT_NAME = 'product-image';
  var VT_ATTR = 'data-vt-product-image';

  function supportsViewTransitions() {
    return typeof document.startViewTransition === 'function' || CSS.supports('view-transition-name', 'none');
  }

  function taggedElements() {
    return document.querySelectorAll('[' + VT_ATTR + ']');
  }

  function untag(el) {
    el.style.viewTransitionName = '';
    el.removeAttribute(VT_ATTR);
  }

  function tag(el) {
    el.style.viewTransitionName = VT_NAME;
    el.setAttribute(VT_ATTR, 'true');
  }

  
  
  
  function dedupe() {
    var matches = taggedElements();
    if (matches.length <= 1) return;

    var keeper = null;
    for (var i = 0; i < matches.length; i++) {
      if (!matches[i].closest('.swiper-slide-duplicate')) {
        keeper = matches[i];
        break;
      }
    }
    if (!keeper) keeper = matches[0];

    for (var j = 0; j < matches.length; j++) {
      if (matches[j] !== keeper) untag(matches[j]);
    }
  }

  function assignName(el) {
    if (!el) return;
    var current = taggedElements();
    for (var i = 0; i < current.length; i++) untag(current[i]);
    tag(el);
  }

  function findCardImage(link) {
    var card = link.closest('[class*="product-card"]');
    if (!card) return null;
    return card.querySelector('.product-card__image--main img') || card.querySelector('img');
  }

  function handleClick(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }
    var link = event.target.closest('a[href*="/products/"]');
    if (!link) return;
    var img = findCardImage(link);
    if (img) {
      assignName(img);
      dedupe();
    }
  }

  function init() {
    if (!supportsViewTransitions()) return;

    
    
    var mainMedia = document.querySelector('.product__media-list [data-media-index="0"]:not(.swiper-slide-duplicate) img');
    if (mainMedia) assignName(mainMedia);

    
    
    
    setTimeout(dedupe, 400);
    setTimeout(dedupe, 1200);

    
    
    
    window.addEventListener('pageswap', dedupe);
    window.addEventListener('beforeunload', dedupe);

    
    
    
    document.addEventListener('click', handleClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
